import { categoryList, CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'
import { TEMPLATE_STATE } from '@/store/dict/templateDict.js'

const CAR_CERT_MAP = { 0: '无车证', 1: '有车证' }
const PAY_MODE_MAP = { 3: '周付(自然周)', 4: '月付(满月)', 5: '月付(自然月)', 10: '日付', 12: '周付(自然周)' }


export const STATE_ENUM = {
  ABLE: 10, // 可用（后端使用10表示上架）
  DISABLE: 0, // 不可用
}
export const TYPE_ENUM = {
  ADDOREDIT: 1, // 可用
  DELETE: -1, // 删除
}
export const DIALOG_CONFIG = {
  [STATE_ENUM.ABLE]: {
    type: TYPE_ENUM.ADDOREDIT,
    title: '下架租赁方案',
    contentTxt: '确认下架该租赁方案',
    sureBtnText: '确定',
  },
  [STATE_ENUM.DISABLE]: {
    type: TYPE_ENUM.ADDOREDIT,
    title: '上架租赁方案',
    contentTxt: '确认上架该租赁方案',
    sureBtnText: '确定',
  },
}

// 0: '上架', 1: '下架'
export const STATE_ENUM_TEXT = {
  [STATE_ENUM.ABLE]: '下架',
  [STATE_ENUM.DISABLE]: '上架',
}

export default function () {
  const tableColumns = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '方案ID',
        width: 100,
        fixed: 'left',
      },
      render: ({ row }) => {
        return (
          <el-link
            type="primary"
            onClick={() => this.goDetail(row)}
          >
            {row.id}
          </el-link>
        )
      },
    },
    {
      name: 'showCityCodes',
      columnProps: {
        prop: 'showCityCodes',
        label: '方案所属城市',
        'min-width': 160,
      },
      showEllipsisTooltip: true,
      limitEllipsisLine: 1,
      getText: ({ row }) => {
        const { showCityCodes } = row
        if (showCityCodes?.length === 0) return '--'
        if (showCityCodes.length === 1) {
          return showCityCodes?.[0]
        }
        return showCityCodes.join(',')
      },
    },
    {
      name: 'name',
      columnProps: {
        prop: 'name',
        label: '方案名称',
        'min-width': 160,
      },
    },
    {
      name: 'brandName',
      columnProps: {
        prop: 'brandName',
        label: '品牌',
        'min-width': 100,
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        prop: 'seriesName',
        label: '车系',
        'min-width': 120,
      },
    },
    {
      name: 'modelName',
      columnProps: {
        prop: 'modelName',
        label: '车型',
        'min-width': 160,
      },
    },
    {
      name: 'rentPeriod',
      columnProps: {
        prop: 'rentPeriod',
        label: '租期',
        'min-width': 120,
      },
      getText: ({ row }) => {
        const { rentPeriodType, rentPeriod } = row
        if (rentPeriodType === 1) {
          return `${rentPeriod}天`
        }
        if (rentPeriodType === 3) {
          return `${rentPeriod}个月`
        }
        return '--'
      },
    },
    {
      name: 'rentAmount',
      columnProps: {
        prop: 'rentAmount',
        label: '每期租金(元)',
        'min-width': 100,
      },
    },
    {
      name: 'deposit',
      columnProps: {
        prop: 'deposit',
        label: '押金(元)',
        'min-width': 100,
      },
    },
    {
      name: 'carAge',
      columnProps: {
        prop: 'age',
        label: '车龄',
        'min-width': 120,
      },
      getText: ({ row }) => {
        const item = this.carAgeOptions.find((opt) => opt.code === row.age)
        return item ? item.name : '--'
      },
    },
    {
      name: 'hasDrivingLicense',
      columnProps: {
        prop: 'carCert',
        label: '是否有车证',
        'min-width': 100,
      },
      getText: ({ row }) => CAR_CERT_MAP[row.carCert] || '--',
    },
    {
      name: 'paymentMethod',
      columnProps: {
        prop: 'payMode',
        label: '收款方式',
        'min-width': 120,
      },
      getText: ({ row }) => PAY_MODE_MAP[row.payMode] || '--',
    },
    {
      name: 'rentCategory',
      columnProps: {
        prop: 'rentCategory',
        label: '租赁类型',
        'min-width': 120,
      },
      getText: ({ row }) => categoryList[row.rentCategory] || '--',
    },
    {
      name: 'templateName',
      columnProps: {
        prop: 'templateName',
        label: '合同模板名称',
        'min-width': 160,
      },
    },
    {
      name: 'contractStatus',
      columnProps: {
        prop: 'templateState',
        label: '合同状态',
        'min-width': 120,
      },
      getText: ({ row }) => TEMPLATE_STATE[row.templateState] || '--',
    },
    {
      name: 'state',
      columnProps: {
        prop: 'state',
        label: '上架状态',
        'min-width': 100,
      },
      render: ({ row }) => {
        const tagConfig = {
          [STATE_ENUM.ABLE]: { type: 'success', label: '上架' },
          [STATE_ENUM.DISABLE]: { type: 'info', label: '下架' },
        }
        const config = tagConfig[row.state] || { type: 'info', label: '--' }
        return <el-tag type={config.type}>{config.label}</el-tag>
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 160,
        fixed: 'right',
      },
      type: 'operate',
      maxShowLength: 4,
      getOperateList: ({ row }) => {
        const btns = []
        const { state } = row

        // 上下架（司机合作模式不展示）
        if (
          row.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI &&
          row.rentCategory !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU &&
          this.judgePermission('for_rent_config_ren_plan_up_and_down')
        ) {
          btns.push({
            label: state === STATE_ENUM.ABLE ? '下架' : '上架',
            action: () => this.clickHandle(row, { type: TYPE_ENUM.ADDOREDIT }),
          })
        }

        // 编辑
        if (this.judgePermission('for_rent_config_ren_plan_edit')) {
          btns.push({
            label: '编辑',
            action: () => this.goEditPage(row),
          })
        }

        // 复制
        if (this.judgePermission('for_rent_config_ren_plan_copy')) {
          btns.push({
            label: '复制',
            action: () => this.copy(row),
          })
        }

        // 删除（仅下架状态）
        if (
          state === STATE_ENUM.DISABLE &&
          this.judgePermission('for_rent_config_ren_plan_delete')
        ) {
          btns.push({
            label: '删除',
            action: () => this.deleteHandle(row),
          })
        }

        return btns
      },
    },
  ]

  const urlMap = {
    workbench_rent_order: {
      path: '/workbench/rentOrder/list',
      query: {},
    },
    for_rent_sign_contract: {
      path: '/car_to_lease/forRentSignContract',
      query: {},
    },
  }
  return {
    tableColumns,
    urlMap,
  }
}
